import { render } from "./personalsettingView.vue?vue&type=template&id=1619e5f4&scoped=true"
import script from "./personalsettingView.vue?vue&type=script&lang=js"
export * from "./personalsettingView.vue?vue&type=script&lang=js"

import "./personalsettingView.vue?vue&type=style&index=0&id=1619e5f4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1619e5f4"]])

export default __exports__